<template>
    <div class="content_module">
         <div class="back">WEINVENT</div>
         <div class="content">
            <p class="title1">{{about_us.name}}</p>
            <p class="title2">{{about_us.value}}</p>
            <p class="title3"><span></span></p>
            <div class='cont'>
            <p class='left' v-html='about_us.mes' ref="contentText"></p>
            <img class='right' :src='about_us.img_src' ref="contentImg"/>
            </div>
         </div>
    </div>
</template>

<script>
export default {
  name: 'about-us',
  props:["about_us"],
  data () {
    return {
    }
  },
  mounted () {
    let self = this
    let rightReveal=self.$root.$data.rightReveal
    let leftReveal=self.$root.$data.leftReveal
    let topReveal=self.$root.$data.topReveal
    let fooReveal=self.$root.$data.fooReveal
    let fadeReveal=self.$root.$data.fadeReveal
    self.$scroll().reveal(self.$refs.contentImg,rightReveal)
    self.$scroll().reveal(self.$refs.contentText,leftReveal)
  },

}
</script>

<style scoped>
@import '../../../static/css/common.css';

.cont{
    display:flex;
    justify-content:space-around;
    margin-bottom:58px;
    margin-top:30px;
}
.content_module .content .left{
    width: 50%;
    font-size:16px;
    line-height:36px;
    color:#656464;
    padding-right:20px;
    text-align:justify;
    text-indent:2em;
    display:inline-block;
}
.content_module .content .right{
    width: 50%;
    height: 300px;
    z-index: 1;
}
</style>
<style scoped>
    @media screen and (max-width: 1026px){
        .cont{
            display:flex;
            flex-flow: wrap;
        }
        .content_module .content .left{
            width: 100%;
        }
        .content_module .content .right{
            width: 64%;
            height: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/about_us.vue